import React, { useEffect, useState } from "react";
import type { CurrentSiteState } from "../../../redux/modules/currentSite/reducer";
import { ensureCurrentSite } from "../../../redux/modules/currentSite/asyncActions";
import PageLayout from "../../components/PageLayout";
import NavBar from "../../NavBar/NavBar";
import Jumbotron from "../../components/Jumbotron";
import { Alert, AlertStyleType, Loader } from "@traceair/tds";
import { connect } from "react-redux";
import { getCurrentSiteState } from "../../../redux/modules/rootReducer";
import SrsConfigurationForm from "./SrsConfigurationForm";
import CenterLayout from "../../components/CenterLayout";

interface ISrsConfigurationPageProps {
  customerId: string;
  siteId: string;
  // Struggling to come up with correct type. Not that important for now,
  // ideally would be great to drop redux at all.
  dispatch: Function;
  currentSiteState: CurrentSiteState;
}

const SrsConfigurationPage = ({
  customerId,
  siteId,
  dispatch,
  currentSiteState,
}: ISrsConfigurationPageProps) => {
  const [pending, setPending] = useState(true);
  const [error, setError] = useState<string>("");
  const site = currentSiteState.data;

  useEffect(() => {
    setPending(true);
    dispatch(ensureCurrentSite(customerId, siteId))
      .catch((e: Error) => {
        setError(e.message);
      })
      .finally(() => setPending(false));
  }, [dispatch, customerId, siteId]);

  return (
    <PageLayout
      navBar={<NavBar />}
      header={
        <Jumbotron
          imageUrl={"logo-dashboard-crs.svg"}
          header={"CRS Configuration"}
          subheader={null}
        />
      }
      content={(() => {
        if (pending) {
          return (
            <CenterLayout>
              <Loader />
            </CenterLayout>
          );
        }
        if (error) {
          return (
            <Alert
              description={error}
              type={AlertStyleType.WarnA}
              header="Error"
            />
          );
        }
        if (site) {
          return (
            <SrsConfigurationForm
              customerId={customerId}
              siteId={siteId}
              site={site}
              dispatch={dispatch}
            />
          );
        }
        return <Alert type={AlertStyleType.WarnA} header="Invalid state" />;
      })()}
    />
  );
};

export default connect((state) => ({
  currentSiteState: getCurrentSiteState(state),
}))(SrsConfigurationPage);
